import type { ModuleId } from '../data/types';
import { REPORT_ANCHOR_ATTR, reportAnchorId } from '../constants';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const VISIBILITY_TOLERANCE_PX = 1;

const moduleSelector = (id: ModuleId) => `[data-report-module="${id}"]`;

// Account numbers come from upstream unchecked; a quote or backslash would break the selector.
const escapeAttrValue = (value: string) => value.replace(/["\\]/g, '\\$&');

export const isFullyVisibleIn = (container: HTMLElement, target: Element): boolean => {
    const c = container.getBoundingClientRect();
    const t = target.getBoundingClientRect();
    const viewTop = c.top + container.clientTop;
    const viewBottom = viewTop + container.clientHeight;
    const visible = Math.min(t.bottom, viewBottom) - Math.max(t.top, viewTop);
    return visible >= Math.min(t.height, container.clientHeight) - VISIBILITY_TOLERANCE_PX;
};

const alignTargetToTop = (container: HTMLElement, target: Element) => {
    const offset = target.getBoundingClientRect().top - container.getBoundingClientRect().top;
    if (Math.abs(offset) <= VISIBILITY_TOLERANCE_PX) return;
    container.scrollTo({
        top: container.scrollTop + offset,
        behavior: window.matchMedia(REDUCED_MOTION_QUERY).matches ? 'auto' : 'smooth',
    });
};

export const scrollPreviewToAnchor = (container: HTMLElement, selector: string): boolean => {
    const target = container.querySelector(selector);
    if (!target) return false;
    if (!isFullyVisibleIn(container, target)) alignTargetToTop(container, target);
    return true;
};

export const scrollPreviewToModule = (container: HTMLElement, id: ModuleId): boolean => {
    const target = container.querySelector(moduleSelector(id));
    if (!target) return false;
    alignTargetToTop(container, target);
    return true;
};

export const scrollPreviewToSubOption = (container: HTMLElement, moduleId: ModuleId, subId: string): boolean =>
    scrollPreviewToAnchor(container, `[${REPORT_ANCHOR_ATTR}="${escapeAttrValue(reportAnchorId(moduleId, subId))}"]`) ||
    scrollPreviewToAnchor(container, moduleSelector(moduleId));
